<template>
  <div class="timeline-step" data-test-id="timeline-step">
    <Typography variant="h-5">
      Select the date you want your program to start and when you want it to end.
    </Typography>

    <v-form ref="form">
      <div class="date-row">
        <DateTimeField
          class="date-input"
          label="Start date*"
          :value="startDate"
          :rules="startRules"
          @input="$emit('update:startDate', $event)"
        />
        <Typography variant="h-5" as="span" class="pt-4">–</Typography>
        <DateTimeField
          ref="endField"
          class="date-input"
          label="End date*"
          :value="endDate"
          :min="startDate"
          :rules="endRules"
          @input="$emit('update:endDate', $event)"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import DateTimeField from "@/components/generic/form-inputs/DateTimeField.vue";
import moment from "moment";

export default {
  name: "TimelineStep",
  components: {
    Typography,
    DateTimeField,
  },
  props: {
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
  },
  emits: ["update:startDate", "update:endDate"],
  computed: {
    startRules() {
      return [() => !!this.startDate || "A start date is required"];
    },
    endRules() {
      return [
        () => !!this.endDate || "An end date is required",
        () =>
          !this.endDate ||
          !this.startDate ||
          moment(this.endDate).isAfter(moment(this.startDate)) ||
          "End date must be after start date",
      ];
    },
  },
  watch: {
    startDate() {
      if (this.endDate) this.$refs.endField?.validate(true);
    },
    endDate() {
      this.$refs.endField?.validate(true);
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style scoped>
.timeline-step {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.date-row {
  display: flex;
  align-items: start;
  gap: 24px;
}

.date-input {
  flex: 1 1 0;
  min-width: 0;
}
</style>
